import React, {useState, useRef, useEffect} from 'react';
//import Layout from './Layout'
//import LayoutEditor from './layout/LayoutEditor'
import CustomTheme from './layout/CustomTheme';
import {useLocalStorage} from './hooks/useLocalStorage';
import { BrowserRouter } from "react-router-dom";
import Router from './Router';
import Layout from './layout/Layout';
import './App.css'

export const ThemeContext = React.createContext('');

function App() {
  
  const [theme, setCurrentTheme] = useLocalStorage(
    'contextTheme',
    (window.matchMedia("(prefers-color-scheme: dark)") ? 'dark' : 'light')
    );
  
 // console.log(theme);


  return (
    <>
    <ThemeContext.Provider value={[theme,setCurrentTheme]}>
      <CustomTheme>
      {/* <LayoutEditor/> */}
      <BrowserRouter>
        <Layout></Layout>
      </BrowserRouter>
      </CustomTheme>
    </ThemeContext.Provider>
    </>
  );
}

export default App;
